import React from 'react';

import LandingPage from '../../js/pages/AffiliateLandingPage';

export default function AffiliatePage() {
  return <LandingPage />;
}
